import type * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateUserFeedbackMutationVariables = Types.Exact<{
  input: Types.CreateUserFeedbackInput;
}>;


export type CreateUserFeedbackMutation = { __typename?: 'RootMutationType', createUserFeedback: { __typename?: 'CreateUserFeedbackResult', result?: { __typename?: 'UserFeedback', id: string } | null, errors: Array<{ __typename?: 'MutationError', message?: string | null, code?: string | null, fields?: Array<string> | null }> } };


export const CreateUserFeedbackDocument = gql`
    mutation CreateUserFeedback($input: CreateUserFeedbackInput!) {
  createUserFeedback(input: $input) {
    result {
      id
    }
    errors {
      message
      code
      fields
    }
  }
}
    `;
export type CreateUserFeedbackMutationFn = Apollo.MutationFunction<CreateUserFeedbackMutation, CreateUserFeedbackMutationVariables>;

/**
 * __useCreateUserFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateUserFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserFeedbackMutation, { data, loading, error }] = useCreateUserFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserFeedbackMutation, CreateUserFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserFeedbackMutation, CreateUserFeedbackMutationVariables>(CreateUserFeedbackDocument, options);
      }
export type CreateUserFeedbackMutationHookResult = ReturnType<typeof useCreateUserFeedbackMutation>;
export type CreateUserFeedbackMutationResult = Apollo.MutationResult<CreateUserFeedbackMutation>;
export type CreateUserFeedbackMutationOptions = Apollo.BaseMutationOptions<CreateUserFeedbackMutation, CreateUserFeedbackMutationVariables>;